import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import Quill from 'quill';
// import '../quill-modules/search-booksy';
// import quillTextImage from '../quill-modules/quill-text-image';
// Quill.register('modules/text-image', quillTextImage);
// import quillDivider from '../quill-modules/quill-divider';
// Quill.register('modules/divider', quillDivider);
// import '../quill-modules/image';
// import BlotFormatter from 'quill-blot-formatter';
// Quill.register('modules/blotFormatter', BlotFormatter);
// import MagicUrl from 'quill-magic-url';
// Quill.register('modules/magicUrl', MagicUrl);
// import { ImageUpload } from 'quill-image-upload';
// import { environment } from '../environments/environment';
// Quill.register('modules/imageUpload', ImageUpload);

// import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html';

const tagsToRemove = ['script', 'meta'];
const attributesToRemove = ['onload', 'onerror', 'onmouseover'];

@Injectable({
  providedIn: 'root',
})
export class ContentWysiwygService {
  quill: any;

  constructor() {
    // this.initQuill();
  }

  initQuill() {
    // specify the fonts you would
    const fonts = [
      'Arial',
      'bodoni-urw',
      'Courier',
      'Garamond',
      'Roboto',
      'Tahoma',
      'Times New Roman',
      'Verdana',
    ];
    // generate code friendly names
    function getFontName(font) {
      return font.toLowerCase().replace(/\s/g, '-');
    }
    const fontNames = fonts.map((font) => getFontName(font));
    // add fonts to style
    let fontStyles = '';
    fonts.forEach(function (font) {
      const fontName = getFontName(font);
      fontStyles +=
        '.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=' +
        fontName +
        ']::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=' +
        fontName +
        ']::before {' +
        "content: '" +
        font +
        "';" +
        "font-family: '" +
        font +
        "', sans-serif;" +
        '}' +
        '.ql-font-' +
        fontName +
        '{' +
        " font-family: '" +
        font +
        "', sans-serif;" +
        '}';
    });
    const node = document.createElement('style');
    node.innerHTML = fontStyles;
    document.body.appendChild(node);

    const Font = Quill.import('formats/font');
    Font.whitelist = fontNames;
    Quill.register(Font, true);

    const toolbarOptions = {
      container: [
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        ['blockquote', 'code-block'],

        // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        // [{ 'direction': 'rtl' }],                         // text direction

        [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
        [{ header: [1, 2, 3, 4, 5, 6, false] }],

        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        [{ font: fontNames }],
        [{ align: [] }],
        ['link', 'image', 'video'],
        ['clean'],
        ['search-booksy'],
        ['text-image'],
        ['divider'], // remove formatting button
      ],
      handlers: {
        'search-booksy': function () {},
        'text-image': function () {},
        divider: function () {},
      },
    };

    // let div = document.createElement('div');

    // this.quill = new Quill(div, {
    //   theme: 'snow',
    //   modules: {
    //     table: false, // disable table module
    //     'text-image': true,
    //     divider: true,
    //     blotFormatter: {},
    //     toolbar: toolbarOptions,
    //     magicUrl: true,
    //     'search-booksy': true
    //   }
    // });
  }

  cleanJson(json) {
    if (json.child) {
      this.removeTags(json.child);
    }
    return json;
  }

  removeAttributes(attributes) {
    // tslint:disable-next-line: forin
    for (const key in attributes) {
      if (attributesToRemove.indexOf(key.toLocaleLowerCase()) !== -1) {
        console.log(key);
        delete attributes[key];
      }
    }
    return attributes;
  }

  removeTags(elements) {
    if (elements.length > 0) {
      elements.forEach((element, index) => {
        // console.log(element);
        if (element.child) {
          element.child = this.removeTags(element.child);
        }
        if (element.attr) {
          element.attr = this.removeAttributes(element.attr);
        }
        if (tagsToRemove.indexOf(element.tag) !== -1) {
          delete elements[index];
        }
      });
    }

    return elements;
  }

  toHTML(text) {
    const type = this.getType(text);
    switch (type) {
      case 'quill':
        // const cfg = {
        //   inlineStyles: true,
        // };
        // const converter = new QuillDeltaToHtmlConverter(
        //   JSON.parse(text).ops,
        //   cfg
        // );
        // const html = converter.convert();
        // return html;
        break;
      case 'text':
        return text.replace(/(?:\r\n|\r|\n)/g, '<br>');
      case 'json':
        return this.jsonToHtml(text);
    }
  }

  isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  jsonParse(string) {
    return JSON.parse(string);
  }

  jsonToHtml(text) {
    const json2html = require('html2json').json2html;
    console.warn('TEXT!!!!!!', text);
    if (text) {
      const json = JSON.parse(text);
      const cleanJson = this.cleanJson(json);
      const html = json2html(cleanJson);
      return html;
    }
  }

  htmlToJson(text) {
    const html2json = require('html2json').html2json;
    if (text) {
      const json = html2json(text);
      const cleanJson = json; //this.cleanJson(json);
      return JSON.stringify(cleanJson);
    }
  }

  getType(text) {
    let type = '';
    const isJson = this.isJsonString(text);
    if (isJson) {
      type = 'json';
      if (JSON.parse(text).ops) {
        type = 'quill';
      }
    } else {
      type = 'text';
    }
    return type;
  }

  uploadHandler(blobInfo, success, failure) {
    let xhr;

    xhr = new XMLHttpRequest();
    xhr.withCredentials = false;
    xhr.open('POST', `${environment.apiUrl}/panel/image`);
    if (typeof sessionStorage !== 'undefined') {
      xhr.setRequestHeader(
        'Authorization',
        'Bearer ' + sessionStorage.getItem(environment.projectName + '_token')
      );
    }
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    xhr.responseType = 'json';

    xhr.onload = function () {
      let json;

      if (xhr.status != 200) {
        failure('HTTP Error: ' + xhr.status);
        return;
      }

      success(xhr.response.original_image);
    };

    const filename = blobInfo.filename();
    const reader = new FileReader();
    const image = {
      name: '',
      content: '',
    };
    reader.onload = () => {
      image.name = filename;
      const base64 = reader.result as string;
      image.content = base64.split(',')[1];
      xhr.send(JSON.stringify({ image: image, name: filename }));
    };
    reader.readAsDataURL(blobInfo.blob());
  }
}
